import * as React from 'react';

import { Row, Space, Text, Column } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import { InformationElectronicBillSkeleton, NameText } from 'components';
import {
  ClockFilledIcon,
  CreditCardIcon,
  HomeFilledIcon,
} from 'components/Icon';
import { env } from 'env';
import { selectAppState } from 'slice';
import { theme } from 'styled';
import {
  formatDate,
  ORDER_DELIVERY_METHOD_TEXT,
  ORDER_PAYMENT_METHOD_TEXT,
} from 'utils';

import { CQRCode, OrderInformationOtherWrapper } from './styles';

interface OrderInformationOtherProps {
  data: any;
  isLoading: boolean;
  isPrint?: boolean;
  isCart?: boolean;
}

const OrderInformationOther = ({
  data,
  isLoading,
  isPrint = false,
  isCart = false,
}: OrderInformationOtherProps): JSX.Element => {
  const app = useAppSelector(selectAppState);
  if (isLoading) {
    return <InformationElectronicBillSkeleton />;
  }

  return (
    <OrderInformationOtherWrapper>
      <Row styles={{ gap: 12 }}>
        <Text
          color="dark"
          styles={isPrint ? { color: '#000000' } : {}}
          weight="bold"
        >
          Thông tin đơn hàng
        </Text>
      </Row>
      <Space height={12} />
      <Row justifyContent="space-between">
        <Column
          alignItems="flex-start"
          styles={{
            gap: 18,
            flexWrap: 'wrap',
            borderLeft: `1px solid ${isPrint ? '#000000' : '#efefef'}`,
            paddingLeft: '18px',
          }}
          width="fit-content"
        >
          <>
            <Row styles={{ gap: 6, flexShrink: 0 }} width="fit-content">
              <ClockFilledIcon
                color={isPrint ? '#000000' : theme.colors.icon.secondary}
                height={14}
                width={14}
              />
              <Text color={isPrint ? 'black' : 'secondary'}>
                {formatDate(data.createdAt, 'HH:mm:ss DD/MM/YYYY')}
              </Text>
            </Row>

            <Row
              alignItems="center"
              styles={{ gap: 6, flexShrink: 0 }}
              width="fit-content"
            >
              <HomeFilledIcon
                color={isPrint ? '#000000' : theme.colors.icon.secondary}
                height={14}
                width={14}
              />
              <Text color={isPrint ? 'black' : 'secondary'}>
                {ORDER_DELIVERY_METHOD_TEXT[data.deliveryMethod]}
              </Text>
            </Row>

            <Row
              alignItems="center"
              styles={{ gap: 6, flexShrink: 0 }}
              width="fit-content"
            >
              <CreditCardIcon
                color={isPrint ? '#000000' : theme.colors.icon.secondary}
                height={14}
                width={14}
              />
              <Text color={isPrint ? 'black' : 'secondary'}>
                {ORDER_PAYMENT_METHOD_TEXT[data.paymentMethod]}
              </Text>
              <Text
                color={data.isPaid ? 'main' : 'red'}
                styles={isPrint ? { color: '#000000' } : {}}
              >
                ({data.isPaid ? 'Đã' : 'Chưa'} thanh toán)
              </Text>
            </Row>
          </>
        </Column>

        {!isCart && (
          <Column alignItems="center" width="120px">
            <CQRCode
              level="L"
              renderAs="svg"
              value={`${
                app?.domains?.hubBilling?.domain ?? env.service.hubbillingWebApp
              }/${data.code}`}
            />
            <Space height={4} />
            <NameText
              color="black"
              lineHeight="18px"
              lineNumber={2}
              size="tiny"
              styles={{ 'text-align': 'center' }}
              weight="bold"
            >
              Mã thông tin hóa đơn
            </NameText>
          </Column>
        )}
      </Row>
    </OrderInformationOtherWrapper>
  );
};

export default OrderInformationOther;
